import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import { createSuccessStory } from '../../../lib/community';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ReactMarkdown from 'react-markdown';

function getYoutubeEmbedUrl(url) {
  // https://www.youtube.com/watch?v=xxxx 또는 https://youtu.be/xxxx
  const match = url.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]{11})/
  );
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

const SuccessStoryForm = ({ open, onClose, onSuccess }) => {
  const [form, setForm] = useState({
    title: '',
    content: '',
    examDate: '',
    examScore: '',
    studyPeriod: '',
    state: '',
    youtubeUrl: ''
  });
  const [loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleQuillChange = value => {
    setForm(prev => ({ ...prev, content: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        title: form.title,
        content: form.content,
        exam_date: form.examDate || null,
        exam_score: form.examScore ? Number(form.examScore) : null,
        study_period: form.studyPeriod || null,
        state: form.state || null,
        youtube_url: form.youtubeUrl || null
      };
      console.log('payload:', payload);
      await createSuccessStory(payload);
      onSuccess();
      onClose();
    } catch (err) {
      alert('저장 실패: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>합격 스토리 작성</DialogTitle>
      <DialogContent>
        <TextField label="제목" name="title" value={form.title} onChange={handleChange} fullWidth margin="normal" required />
        <div style={{ marginBottom: 8, fontWeight: 600 }}>내용 (HTML 가능, 마크다운도 지원)</div>
        <ReactQuill
          value={form.content}
          onChange={handleQuillChange}
          theme="snow"
          style={{ height: 200, marginBottom: 16 }}
        />
        <Button onClick={() => setShowPreview(v => !v)} size="small" sx={{ mb: 1 }}>
          {showPreview ? '프리뷰 숨기기' : '마크다운 프리뷰 보기'}
        </Button>
        {showPreview && (
          <div style={{ padding: 8, border: '1px solid #eee', borderRadius: 4, background: '#fafafa', marginBottom: 16 }}>
            <ReactMarkdown>{form.content}</ReactMarkdown>
          </div>
        )}
        {form.youtubeUrl && getYoutubeEmbedUrl(form.youtubeUrl) && (
          <div style={{ margin: '16px 0' }}>
            <iframe
              width="100%"
              height="315"
              src={getYoutubeEmbedUrl(form.youtubeUrl)}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
        <TextField label="시험일" name="examDate" type="date" value={form.examDate} onChange={handleChange} fullWidth margin="normal" InputLabelProps={{ shrink: true }} required />
        <TextField label="점수" name="examScore" value={form.examScore} onChange={handleChange} fullWidth margin="normal" required />
        <TextField label="공부 기간" name="studyPeriod" value={form.studyPeriod} onChange={handleChange} fullWidth margin="normal" required />
        <TextField label="합격 상태" name="state" value={form.state} onChange={handleChange} fullWidth margin="normal" required />
        <TextField
          label="유튜브 링크"
          name="youtubeUrl"
          value={form.youtubeUrl || ''}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>취소</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>저장</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessStoryForm;